<div class="header-options" *ngIf="companyService.getOptionHeaderStyle()===optionEnum.DEFAULT">

    <!-- HEADER CONTENEDOR -->
    <div class="line" *ngIf="dataCompany" [ngStyle]="{ 'border-bottom': '7px solid ' + colorPrimario }">
        <!--<div class="line">-->
        <div class="nav">
            <a *ngIf="dataCompany" href="https://{{ dataCompany.webSite }}" class="logo">
                <img *ngIf="dataCompany" src="{{companyLogo}}{{ dataCompany.logo }}" height="66" alt="logo" />
            </a>
            <div class="headtitle">
                <h1>Book your Cruise Online</h1>
                <div class="menurow" *ngIf="dataCompany && menus?.length === 1">

                    <p *ngFor="let item of menus"><strong>{{item.name}}:</strong> {{ dataCompany.phone }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="header-options" *ngIf="companyService.getOptionHeaderStyle()===optionEnum.ROYAL">

    <app-header-white-brand *ngIf="dataCompany " [dataCompany]="dataCompany"></app-header-white-brand>
</div>
